import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import { DreamCompleteDropTarget } from "./DreamDropTarget/DreamCompleteDropTarget";
import { DreamDeleteDropTarget } from "./DreamDropTarget/DreamDeleteDropTarget";
import { DreamResonanceDropTarget } from "./DreamDropTarget/DreamResonanceDropTarget";
import * as localStyles from "./DreamRow.css";

export function DreamRowDropTargets({ dream }: { dream: IDream }) {
    return (
        <div className={localStyles.dropTargetsContainer}>
            <DreamResonanceDropTarget dream={dream} />
            <DreamCompleteDropTarget dream={dream} />
            <DreamDeleteDropTarget dream={dream} />
        </div>
    );
}
